// Vue
import Vue from "vue";

// Libraries
import Router from "vue-router";

// Store
import { Store } from "#/store";
import Page from "#/views/page/Page";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: APP_BASE_URL,
  routes: [
    {
      path: "*",
      name: "home",
      component: Page,
    },
  ],
});

const promise = new Promise((resolve) => {
  (router as any).start = resolve;
});

router.beforeEach(async (to, from, next) => {
  const store = Store.instance;

  await promise;

  if (to.meta) store.ui.routeTitleKey = to.meta.titleKey;

  store.ui.routeName = to.name!;

  next();
});

/*router.afterEach((to, from) => {

    const store = Store.instance

    if (store.ui.willLoadingBeHandled) {

        store.ui.willLoadingBeHandled = false
    } else {

        store.ui.isLoadingAuto = true
        store.ui.isLoading = false
        store.ui.willLoadingBeHandled = false
    }
})*/

export { router };
